import FlagGhana from "@zenith/assets/icons/FlagGhana";
import FlagNigeria from "@zenith/assets/icons/FlagNigeria";
import { GH, NG } from "@zenith/data/constants";

/**
 * Gets the country flag
 * based on the country code provided.
 * @function
 * @name getCountryFlag
 * @kind function
 * @param {string} countryCode The country code provided.
 * @returns {React.ReactNode} The country flag.
 * @exports
 */
export function getCountryFlag(countryCode: string): React.ReactNode {
  switch (countryCode) {
    case NG:
      return <FlagNigeria />;

    case GH:
      return <FlagGhana />;

    default:
      return "";
  }
}
